export default __webpack_public_path__ + "static/media/nine_of_swords.ee55e2f1.png";